import { useFetchWalletBalance } from "@verde/entities";
import { ChevronDownIcon, CircleStackIcon } from "@verde/icons";
import { IconButton, Skeleton, Tag } from "@verde/ui-core";
import React from "react";
import { tv } from "tailwind-variants";

interface CreditBarTriggerProps {
  handleOpen?: () => void;
  classNames?: Partial<{
    base: string;
  }>;
}

const styles = tv({
  slots: {
    base: "flex h-10 items-center gap-2 rounded border border-neutral-light-2 bg-neutral-light-1 px-3",
  },
});

function CreditBarTrigger({ classNames, handleOpen }: CreditBarTriggerProps) {
  const { data, isLoading } = useFetchWalletBalance();

  if (isLoading) {
    return <Skeleton height={40} />;
  }

  return (
    <div
      className={styles().base({
        className: classNames?.base,
      })}
    >
      <div className="flex w-full items-center justify-between gap-2">
        <p className="text-base font-semibold text-neutral-dark-1">
          Créditos para consultar
        </p>
        <div className="relative h-[1px] min-w-[20px] flex-1 bg-neutral-light-3" />
        <Tag
          icon={<CircleStackIcon />}
          kind={data?.value ? "success" : "highlight"}
          label={data?.value || 0}
        />
      </div>

      {handleOpen && (
        <IconButton onClick={handleOpen}>
          <ChevronDownIcon />
        </IconButton>
      )}
    </div>
  );
}

export default React.memo(CreditBarTrigger);
